import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "review-actions" }

import { useRoute } from 'vue-router';
import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;
const route = useRoute();

function endpointPrefix(): string {
    const modelLabel = route.params.modelLabel as string;
    return modelLabel === 'reviews.eventreview' ? 'event-reviews' : 'user-reviews';
}

const reviewId = (): string => String(props.detail.id);

async function doHide(): Promise<void> {
    const reason = window.prompt('Укажите причину скрытия (необязательно):') ?? '';
    if (reason === null) return;
    await request({
        method: 'post',
        url: `/admin-api/${endpointPrefix()}/${reviewId()}/hide/`,
        data: { reason },
    });
    window.location.reload();
}

async function doUnhide(): Promise<void> {
    if (!window.confirm('Показать отзыв?')) return;
    await request({
        method: 'post',
        url: `/admin-api/${endpointPrefix()}/${reviewId()}/unhide/`,
        data: {},
    });
    window.location.reload();
}

async function doMarkInappropriate(): Promise<void> {
    if (!window.confirm('Отметить отзыв как неприемлемый?')) return;
    await request({
        method: 'post',
        url: `/admin-api/${endpointPrefix()}/${reviewId()}/mark-inappropriate/`,
        data: {},
    });
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.detail.is_hidden)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn",
          onClick: doUnhide
        }, "Показать"))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn--danger",
          onClick: doHide
        }, "Скрыть")),
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: doMarkInappropriate
    }, "Отметить как неприемлемый")
  ]))
}
}

})